
import { useContext } from '@nuxtjs/composition-api';
import useUserInQuarantine from '@/composable/checkout/validations/useUserInQurantine';
import useUtilities from '@/composable/useUtilities';
import useFlow from '~/composable/checkout/config/useFlow';
import useCheckout from '~/composable/checkout/useCheckout';

export default {
  props: {
    errorMessage: {
      type: String,
      default: 'Du kan desværre ikke få rabat, da du enten har et Play abonnement, eller har haft et inden for de sidste 6 måneder. Du er velkommen til at fortsætte med samme abonnement til fuld pris.'
    }
  },
  setup(_props, { emit }) {
    const { app } = useContext()
    const { state } = useCheckout(app)
    const { subscription, setUserInQuarantine, isUserInQuarantine, isMobileBroadBandSubscription, setFullPriceSubscriptionDetails, fullPriceSubscriptionName } = useUserInQuarantine(app)
    const { getSubscriptionName } = useUtilities()
    const {
      validationResponse
    } = useFlow(app, state)

    const actionButtonClicked = () => {
      setUserInQuarantine()
      emit('actionButtonClicked')
    }
    setFullPriceSubscriptionDetails(validationResponse.value)
    return {
      fullPriceSubscriptionName,
      isMobileBroadBandSubscription,
      isUserInQuarantine,
      subscription,
      actionButtonClicked,
      getSubscriptionName
    }
  }
}
